__turbopack_context__.v({
  "aspectBox": "CardStoryGrid-module-scss-module__3oMkEW__aspectBox",
  "date": "CardStoryGrid-module-scss-module__3oMkEW__date",
  "fade-in": "CardStoryGrid-module-scss-module__3oMkEW__fade-in",
  "image": "CardStoryGrid-module-scss-module__3oMkEW__image",
  "link": "CardStoryGrid-module-scss-module__3oMkEW__link",
  "listItem": "CardStoryGrid-module-scss-module__3oMkEW__listItem",
  "root": "CardStoryGrid-module-scss-module__3oMkEW__root",
  "storyDate": "CardStoryGrid-module-scss-module__3oMkEW__storyDate",
  "storyHeadline": "CardStoryGrid-module-scss-module__3oMkEW__storyHeadline",
  "storyHeadlineWrapper": "CardStoryGrid-module-scss-module__3oMkEW__storyHeadlineWrapper",
  "storySubHeadline": "CardStoryGrid-module-scss-module__3oMkEW__storySubHeadline",
  "textBlock": "CardStoryGrid-module-scss-module__3oMkEW__textBlock",
});
